import React, { useState } from "react";
import "../../styles/Header.css";
import { useDispatch } from "react-redux";
import { logout } from "../../services/LoginAPI.tsx";
import { useMsal } from "@azure/msal-react";
import AlertPopup from "../UI/AlertPopup.tsx";

const NocHeader = ({ levelOne, levelTwo }) => {
  const [modal, setModal] = useState(false);

  const dispatch: any = useDispatch();
  const { instance } = useMsal();
  const handleLogout = () => {
    dispatch(logout(instance));
  };

  const getLevelOneHeader = () => {
    if (levelOne === "Policy" || levelOne === "POSPm") {
      return "Kharif 2025";
    } else if(levelTwo === "Total Claim Count" ) {
      return "2024";
    } else {
      return "Rabi 2024";
    }
  };

  return (
    <>
      <div className="header-container">
        <div className="img-container">
          {/* <img
            alt="header-logo"
            className="header-logo"
            src={require("../../assets/images/kshema_logo.svg").default}
          ></img> */}
          <span className="header-title"> Kshema Finder </span>
          <span className="header-context">
            | Country | {getLevelOneHeader()} | {levelOne ? levelOne : ""}
          </span>
        </div>

        <div className="logoutDiv">
          <button
            className="logout-button"
            onClick={() => {
              setModal(!modal);
            }}
          >
            Logout
          </button>
        </div>
      </div>
      {/* <div className="filters">
        <img
          className="filter-icon"
          alt="filters"
          src={require("../../assets/images/filters_button.svg").default}
        ></img>
      </div> */}
      <AlertPopup
        isOpen={modal}
        toggle={() => {
          setModal(!modal);
        }}
        onAction={handleLogout}
      />
    </>
  );
};

export default NocHeader;
